import { t } from '@lingui/macro';
import { getLocalizedUrl, prefixLocale } from 'helpers/url';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { Author } from 'types/schema';

type Props = {
  title?: string;
  seoTitle?: string;
  seoMainEntityTitle?: string;
  author?: Author;
  datePublished?: string;
  dateModified?: string;
  imageUrl?: string;
  howToTitle?: string;
  howToSteps?: string[];
};

export const SEOHowTo = (props: Props) => {
  const router = useRouter();
  const url =
    'https://firi.com' +
    prefixLocale(router.locale, router.defaultLocale) +
    getLocalizedUrl(router.pathname, router.locale, router.query);

  const schemaOrgWebPage = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    name: props.title,
    url,
    headline: props.seoTitle,
    mainEntityOfPage: {
      '@type': 'HowTo',
      description: props.seoMainEntityTitle,
      author: {
        '@type': 'Person',
        name: props.author?.name,
      },
      publisher: {
        '@type': 'Organization',
        name: 'Firi',
        logo: {
          '@type': 'ImageObject',
          url: 'https://firi.com/images/logos/Firi-Logomark_Blue.png',
        },
      },
      datePublished: props.datePublished,
      dateModified: props.dateModified,
      image: {
        '@type': 'ImageObject',
        url: props.imageUrl,
      },
      step: {
        '@type': 'HowToStep',
        name: props.howToTitle,
        itemListElement: props.howToSteps?.map((value) => ({
          '@type': 'HowToDirection',
          text: value,
        })),
      },
    },
  };

  return (
    <Head>
      <script
        key="structured-seo"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrgWebPage) }}
      />
    </Head>
  );
};
